<ng-template #creditosPanel let-offcanvas>
  <div class="offcanvas-header">
    <div class="w-100">
      <div class="row">
        <div class="col-10">
          <div class="h5 text-secondary mt-2">
            <i class="fas fa-file-invoice-dollar me-2 text-primary"></i>
            Seleccione el crédito
          </div>
        </div>
        <div class="col-2 text-end pt-2">
          <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text bg-light border-end-0">
          <i class="fas fa-search text-muted"></i>
        </span>
        <input type="text" class="form-control border-start-0"
               placeholder="Buscar por número de crédito o saldo..."
               [(ngModel)]="searchTerm" (input)="filterInvoices()" style="box-shadow: none;">
      </div>
    </div>

    <div class="mt-2" *ngIf="!filteredInvoices || filteredInvoices.length < 1">
      <div class="text-center py-4">
        <i class="fas fa-search fa-3x text-muted mb-3"></i>
        <h6 class="text-muted">No se encontraron resultados</h6>
        <p class="text-muted small">Intenta con otro número de crédito</p>
      </div>
    </div>

    <div *ngIf="filteredInvoices && filteredInvoices.length > 0">
      <div class="d-flex align-items-center justify-content-between mb-3 p-2 bg-light rounded">
        <div class="d-flex align-items-center">
          <i class="fas fa-list-ol text-primary me-2"></i>
          <span class="fw-bold text-dark">Créditos Pendientes</span>
        </div>
        <span class="badge bg-primary">
          {{ filteredInvoices.length }} crédito{{ filteredInvoices.length > 1 ? 's' : '' }}
        </span>
      </div>

      <div class="row g-3">
        <div class="col-12" *ngFor="let item of filteredInvoices">
          <div class="card border-2 nc-card"
               [ngClass]="{'border-primary bg-primary-subtle': selectedInvoiceCode == item?.code, 'border-light': selectedInvoiceCode != item?.code}"
               (click)="selectInvoice(item)">
            <div class="card-body p-3">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-center flex-grow-1">
                  <div class="rounded-circle nc-icon p-2 me-3 flex-shrink-0">
                    <i class="fas fa-file-invoice-dollar text-white"></i>
                  </div>
                  <div class="flex-grow-1 min-width-0">
                    <h6 class="mb-1 fw-bold text-dark text-truncate">{{ identificador(item) }}</h6>
                    <div class="d-flex align-items-center flex-wrap gap-2">
                      <small class="text-muted">
                        <i class="fas fa-coins text-primary me-1"></i>
                        Saldo <span class="fw-bold text-dark">{{ item?.dueBalance | number:'1.2-2' }} USD</span>
                      </small>
                      <small class="text-muted">
                        <i class="fas fa-tag text-primary me-1"></i>
                        Original {{ item?.amount | number:'1.2-2' }} USD
                      </small>
                    </div>
                    <small class="text-muted d-block mt-1" *ngIf="item?.date">
                      <i class="fas fa-calendar me-1"></i>{{ item?.date | date:'dd/MM/yyyy' }}
                    </small>
                  </div>
                </div>
                <div class="text-end flex-shrink-0 ms-2">
                  <i class="fas fa-check-circle text-primary" *ngIf="selectedInvoiceCode == item?.code"></i>
                  <i class="fas fa-chevron-right text-muted" *ngIf="selectedInvoiceCode != item?.code"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="container-fluid py-3 nc-page">

  <!-- Cabecera -->
  <div class="d-flex align-items-start justify-content-between mb-3">
    <h5 class="mb-0 fw-bold text-dark">Nota de Crédito</h5>
    <button class="btn btn-sm btn-outline-secondary" (click)="volver()">
      <i class="fas fa-arrow-left me-1"></i> Volver
    </button>
  </div>

  <!-- Ficha del cliente: misma estructura que el perfil del cliente -->
  <div *ngIf="personFull?.person"
       class="bg-white rounded-lg p-4 mb-3 shadow-sm border border-gray-200 nc-person"
       (click)="irAPerfil()" title="Ir al perfil del cliente">
    <div class="flex items-center gap-3">

      <div class="flex-shrink-0">
        <div *ngIf="!personFull?.person?.file_selfie"
             class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 cursor-pointer hover:scale-105 transition-transform duration-200">
          <img *ngIf="personFull?.person?.gender != 'F'" class="w-full h-full object-cover"
               [src]="sanitize('../assets/public/images/avatar.png')">
          <img *ngIf="personFull?.person?.gender == 'F'" class="w-full h-full object-cover"
               [src]="sanitize('../assets/public/images/avatara-female.png')">
        </div>
        <div *ngIf="personFull?.person?.file_selfie"
             class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 cursor-pointer hover:scale-105 transition-transform duration-200">
          <img class="w-full h-full object-cover"
               [src]="sanitize(personFull?.person?.file_selfie?.url)">
        </div>
      </div>

      <div class="flex-1">
        <h2 class="text-lg font-bold text-gray-900 mb-1">
          {{ personFull?.person?.name }} {{ personFull?.person?.lastName }}
        </h2>
        <div class="flex flex-wrap gap-x-4 gap-y-1 text-sm text-gray-600">
          <div class="flex items-center gap-1" *ngIf="getIdentity(personFull)">
            <i class="fas fa-id-card text-blue-600"></i>
            <span>{{ getIdentity(personFull) }}</span>
          </div>
          <div class="flex items-center gap-1" *ngIf="getContact(personFull)">
            <i class="fas fa-phone text-blue-600"></i>
            <span>{{ getContact(personFull) }}</span>
          </div>
          <div class="flex items-center gap-1" *ngIf="getEmailContact(personFull)">
            <i class="fas fa-envelope text-blue-600"></i>
            <span>{{ getEmailContact(personFull) }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Cargando -->
  <div class="text-center py-5" *ngIf="loading">
    <span class="spinner-border text-primary"></span>
    <div class="text-muted small mt-2">Cargando…</div>
  </div>

  <ng-container *ngIf="!loading && selectView === 1">

    <div class="alert alert-info d-flex align-items-center" *ngIf="invoices.length === 0">
      <i class="fas fa-info-circle me-2"></i>
      <div>Este cliente no tiene créditos pendientes a los que aplicar una nota de crédito.</div>
    </div>

    <div class="alert alert-warning d-flex align-items-center" *ngIf="invoices.length > 0 && accounts.length === 0">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <div>
        <strong>No hay cuentas habilitadas</strong>
        <div class="small mt-1">Configure una cuenta de pago con la etiqueta de nota de crédito antes de continuar.</div>
      </div>
    </div>

    <!-- ── Formulario ──────────────────────────────────────────── -->
    <div class="card border-0 shadow-sm mb-3" *ngIf="invoices.length > 0 && accounts.length > 0">
      <div class="card-body p-4">

        <!-- Crédito -->
        <div class="form-group col-12">
          <label class="form-label fw-medium mb-2">
            <i class="fas fa-file-invoice-dollar me-2 text-primary"></i>Crédito
          </label>

          <div class="card border-2 border-light nc-card" (click)="openview(creditosPanel)">
            <div class="card-body p-3">

              <div class="d-flex align-items-center justify-content-between" *ngIf="!invoiceSeleccionado">
                <div class="d-flex align-items-center">
                  <div class="rounded-circle bg-light p-3 me-3">
                    <i class="fas fa-plus text-primary"></i>
                  </div>
                  <div>
                    <span class="fw-medium text-dark">Seleccione el crédito</span>
                    <div class="text-muted small">Toque aquí para elegir uno</div>
                  </div>
                </div>
                <i class="fas fa-chevron-right text-primary" style="font-size: 18px;"></i>
              </div>

              <div class="d-flex align-items-center justify-content-between" *ngIf="invoiceSeleccionado">
                <div class="d-flex align-items-center flex-grow-1">
                  <div class="rounded-circle nc-icon p-3 me-3 flex-shrink-0">
                    <i class="fas fa-file-invoice-dollar text-white"></i>
                  </div>
                  <div class="flex-grow-1 min-width-0">
                    <h6 class="mb-1 fw-bold text-dark">{{ identificador(invoiceSeleccionado) }}</h6>
                    <div class="d-flex align-items-center flex-wrap gap-1">
                      <small class="text-muted">
                        <i class="fas fa-coins text-primary me-1"></i>
                        Saldo <span class="fw-bold text-dark">{{ invoiceSeleccionado.dueBalance | number:'1.2-2' }} USD</span>
                      </small>
                      <small class="text-muted ms-2">
                        <i class="fas fa-tag text-primary me-1"></i>
                        Original {{ invoiceSeleccionado.amount | number:'1.2-2' }} USD
                      </small>
                    </div>
                  </div>
                </div>
                <i class="fas fa-edit text-primary" style="font-size: 18px;"></i>
              </div>

            </div>
          </div>

          <div class="text-muted small mt-1" *ngIf="invoiceSeleccionado">
            <i class="fas fa-info-circle me-1"></i>
            El pago se aplicará sólo a las cuotas de este crédito, en orden.
          </div>
        </div>

        <!-- Cuenta -->
        <div class="form-group col-12 mt-3">
          <div class="form-floating">
            <select class="form-select" id="nc_account" [(ngModel)]="selectedAccountCode" name="account">
              <option value="">Selecione una opción</option>
              <option *ngFor="let a of accounts" [value]="a.code">{{ a.name || a.number }}</option>
            </select>
            <label for="nc_account">Cuenta</label>
          </div>
          <div class="mt-1 d-flex align-items-center flex-wrap gap-2" *ngIf="cuentaSeleccionada">
            <span class="badge bg-info-subtle text-info">{{ cuentaSeleccionada.payment_method?.name }}</span>
            <span class="badge bg-secondary">{{ monedaCuenta }}</span>
            <span class="text-muted small" *ngIf="cuentaSeleccionada.subscriptor_cuenta">
              Cuenta contable {{ cuentaSeleccionada.subscriptor_cuenta }}
            </span>
          </div>
        </div>

        <!-- Tasa de cambio -->
        <div class="mt-3" *ngIf="monedaCuenta === 'BS'">
          <div class="text-start p-3" style="background-color: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6;">
            <span class="text-muted" style="font-size: 18px;">Tasa de cambio: </span>
            <span style="font-size: 18px; font-weight: bold; color: #333;" *ngIf="rate?.amount">
              USD 1 = BS {{ rate.amount | number:'1.2-2' }}
            </span>
            <span class="text-muted" *ngIf="loadingRate">consultando…</span>
            <span class="text-danger" *ngIf="rateError && !loadingRate">
              <i class="fas fa-exclamation-triangle me-1"></i>No hay tasa registrada para esa fecha
            </span>
          </div>
        </div>

        <!-- Fecha del documento -->
        <div class="mt-4">
          <label class="form-label fw-medium mb-3">
            <i class="fas fa-calendar-alt me-2 text-primary"></i>
            Fecha del documento
          </label>

          <div class="d-flex gap-2 mb-3 flex-wrap">
            <button type="button" class="btn btn-sm d-flex align-items-center"
                    [class.btn-primary]="dateOption === 'today'"
                    [class.btn-outline-primary]="dateOption !== 'today'"
                    (click)="setDateOption('today')">
              <i class="fas fa-clock me-1"></i> Hoy
            </button>
            <button type="button" class="btn btn-sm d-flex align-items-center"
                    [class.btn-secondary]="dateOption === 'yesterday'"
                    [class.btn-outline-secondary]="dateOption !== 'yesterday'"
                    (click)="setDateOption('yesterday')">
              <i class="fas fa-calendar-minus me-1"></i> Ayer
            </button>
            <button type="button" class="btn btn-sm d-flex align-items-center"
                    [class.btn-info]="dateOption === 'custom'"
                    [class.btn-outline-info]="dateOption !== 'custom'"
                    (click)="setDateOption('custom')">
              <i class="fas fa-calendar-alt me-1"></i> Otra fecha
            </button>
          </div>

          <div *ngIf="dateOption !== 'custom'" class="mb-3">
            <div class="form-control d-flex align-items-center bg-light">
              <i class="fas fa-calendar me-2 text-muted"></i>
              <span class="fw-medium">{{ fecha | date: 'dd/MM/yyyy' }}</span>
              <span class="ms-2 text-muted small">({{ dateOption === 'today' ? 'Hoy' : 'Ayer' }})</span>
            </div>
          </div>

          <div *ngIf="dateOption === 'custom'" class="mb-3">
            <input type="date" class="form-control" [(ngModel)]="fecha" name="fecha" (change)="onFechaChange()">
          </div>
        </div>

        <!-- Monto: mismo control que "Monto Total" del registro de pago -->
        <div class="form-group col-12 mt-3">
          <div class="form-floating">
            <input currencyMask
                   [options]="{ prefix: monedaCuenta + ' ', thousands: ',', decimal: '.' }"
                   type="text"
                   class="form-control text-capitalize"
                   id="nc_monto"
                   placeholder="0.00"
                   [ngClass]="{'error': excedeSaldo}"
                   [(ngModel)]="montoBs" name="monto">
            <label for="nc_monto" class="label font-weight-normal" style="word-wrap: break-word;">
              <span>Monto Total </span>
            </label>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-1 flex-wrap gap-2">
            <span class="text-muted small" *ngIf="!invoiceSeleccionado">
              Seleccione primero el crédito para conocer el tope.
            </span>
            <span class="small" *ngIf="invoiceSeleccionado">
              <i class="fas fa-hand-paper text-warning me-1"></i>
              Máximo a aplicar:
              <span class="fw-bold text-dark">{{ maxUSD | number:'1.2-2' }} USD</span>
              <span class="text-muted" *ngIf="maxBs !== null"> · {{ maxBs | number:'1.2-2' }} BS</span>
            </span>
            <span class="fw-bold" *ngIf="montoUSD !== null" [class.text-danger]="excedeSaldo">
              {{ montoUSD | number:'1.2-2' }} USD
            </span>
          </div>

          <div class="form-control-feedback help-block text-danger small" *ngIf="excedeSaldo">
            Excede el saldo del crédito ({{ invoiceSeleccionado?.dueBalance | number:'1.2-2' }} USD)
          </div>
        </div>

        <!-- Observaciones -->
        <div class="form-group col-12 mt-3">
          <div class="form-floating">
            <textarea class="form-control" id="nc_obs" placeholder="Observaciones"
                      style="height: 110px;"
                      [(ngModel)]="observaciones" name="obs"></textarea>
            <label for="nc_obs">Observaciones</label>
          </div>
        </div>

        <!-- Respaldo digital: misma fila que "Adjunte el soporte" -->
        <div class="form-group col-12 mt-3">
          <div class="nc-file form-control d-flex align-items-center justify-content-between"
               (click)="fileInput.click()">
            <span class="fw-medium text-dark">Respaldo digital</span>
            <span class="d-flex align-items-center">
              <span class="text-muted me-3 text-truncate" style="max-width: 240px;">
                {{ fileName || 'Adjunte el soporte...' }}
              </span>
              <i class="fas fa-file-upload text-secondary"></i>
            </span>
          </div>
          <input #fileInput type="file" class="d-none" accept=".png,.jpg,.jpeg,.pdf" (change)="onFile($event)">
        </div>

        <!-- Aviso -->
        <div class="alert alert-warning d-flex align-items-start mt-4 mb-0">
          <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
          <div class="small">
            Al aplicar la nota se <b>desactivarán las penalidades</b> de las cuotas que reciban
            el pago, y el monto que ya se hubiera abonado a esas penalidades se devolverá a los
            pagos originales.
          </div>
        </div>

        <!-- Acción -->
        <div class="d-grid mt-4">
          <button type="button" class="btn btn-primary btn-lg"
                  [disabled]="!formValido || saving" (click)="registrar()">
            <div class="d-flex align-items-center justify-content-center">
              <span *ngIf="saving" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!saving" class="fas fa-check me-2"></i>
              <span class="fw-bold">{{ saving ? 'Aplicando…' : 'Aplicar nota de crédito' }}</span>
            </div>
          </button>
        </div>

      </div>
    </div>

  </ng-container>

  <!-- ── Vista 2: comprobante (mismo formato que "Pago Registrado") ──── -->
  <ng-container *ngIf="!loading && selectView === 2 && comprobante">
    <div class="card border-0 shadow-sm">
      <div class="card-body p-4">

        <!-- Encabezado de estado -->
        <div class="text-center mb-4">
          <div class="mb-3">
            <i class="fas fa-check-circle fa-3x text-success"></i>
          </div>
          <h5 class="fw-bold mb-1">Nota de Crédito Aplicada</h5>
          <div>
            <span class="badge text-bg-success">Conciliado</span>
            <span class="badge text-bg-warning ms-1" *ngIf="comprobante?.duplicate">Ya existía</span>
          </div>
        </div>

        <!-- Código -->
        <div class="bg-light rounded p-3 mb-4 text-center"
             *ngIf="comprobante?.payment?.code || comprobante?.payment_code">
          <small class="text-muted d-block">Código del pago</small>
          <span class="fw-bold text-dark" style="font-size: 0.85rem; word-break: break-all;">
            {{ comprobante?.payment?.code || comprobante?.payment_code }}
          </span>
        </div>

        <!-- Montos -->
        <div class="border rounded p-3 mb-4">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-muted">Monto</span>
            <span class="fw-bold fs-5 text-dark">
              {{ comprobante?.payment?.amount_bs | number:'1.2-2' }} {{ comprobante?.cuenta?.currency?.name || 'BS' }}
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted">Monto USD</span>
            <span class="fw-bold text-success">
              $ {{ comprobante?.payment?.amount_usd | number:'1.2-2' }} USD
            </span>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-1">
            <span class="text-muted">Tasa</span>
            <span class="fw-medium text-dark">{{ comprobante?.payment?.rate }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-1"
               *ngIf="comprobante?.payment?.unapplied > 0">
            <span class="text-muted">Sin aplicar</span>
            <span class="fw-bold text-danger">
              $ {{ comprobante?.payment?.unapplied | number:'1.2-2' }} USD
            </span>
          </div>
        </div>

        <!-- Detalle -->
        <div class="mb-4">
          <h6 class="fw-bold text-dark border-bottom pb-2 mb-3">
            <i class="fas fa-info-circle text-primary me-2"></i>Detalle de la nota
          </h6>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Crédito</span>
            <span class="fw-bold text-dark">
              {{ comprobante?.invoice?.identifier || ('CREDIT-' + comprobante?.invoice?.number) }}
            </span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="comprobante?.cuenta">
            <span class="text-muted">Cuenta</span>
            <span class="fw-medium text-dark text-end">
              {{ comprobante?.cuenta?.name || comprobante?.cuenta?.number }}<br>
              <small class="text-muted">{{ comprobante?.cuenta?.payment_method?.name }}</small>
            </span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom"
               *ngIf="comprobante?.cuenta?.subscriptor_cuenta">
            <span class="text-muted">Cuenta contable</span>
            <span class="fw-medium text-dark">{{ comprobante?.cuenta?.subscriptor_cuenta }}</span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom">
            <span class="text-muted">Fecha del documento</span>
            <span class="fw-medium text-dark">{{ comprobante?.fecha | date:'dd/MM/yyyy' }}</span>
          </div>

          <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="comprobante?.archivo">
            <span class="text-muted">Respaldo</span>
            <span class="fw-medium text-dark text-end text-truncate" style="max-width: 60%;">
              {{ comprobante?.archivo }}
            </span>
          </div>

          <div class="d-flex justify-content-between py-2" *ngIf="comprobante?.observaciones">
            <span class="text-muted">Observaciones</span>
            <span class="fw-medium text-dark text-end" style="max-width: 60%;">
              {{ comprobante?.observaciones }}
            </span>
          </div>
        </div>

        <!-- Cuotas afectadas -->
        <div class="mb-4" *ngIf="comprobante?.installments?.length">
          <h6 class="fw-bold text-dark border-bottom pb-2 mb-3">
            <i class="fas fa-list-ol text-primary me-2"></i>Cuotas afectadas
          </h6>
          <div class="d-flex justify-content-between py-2 border-bottom"
               *ngFor="let c of comprobante.installments">
            <span class="text-muted">Cuota {{ c.order }}</span>
            <span class="fw-medium text-dark">$ {{ c.amount | number:'1.2-2' }} USD</span>
          </div>
        </div>

        <!-- Penalidades desactivadas -->
        <div class="mb-4" *ngIf="comprobante?.fees?.deactivated?.length">
          <h6 class="fw-bold text-dark border-bottom pb-2 mb-3">
            <i class="fas fa-ban text-primary me-2"></i>Penalidades desactivadas
          </h6>
          <div class="d-flex justify-content-between py-2 border-bottom"
               *ngFor="let f of comprobante.fees.deactivated">
            <span class="text-muted">{{ f.code_concept }}</span>
            <span class="fw-medium text-dark">$ {{ f.amount | number:'1.2-2' }} USD</span>
          </div>
        </div>

        <!-- Devoluciones a pagos anteriores -->
        <div class="mb-4" *ngIf="comprobante?.fees?.refunded?.length">
          <h6 class="fw-bold text-dark border-bottom pb-2 mb-3">
            <i class="fas fa-undo text-primary me-2"></i>Devuelto a pagos anteriores
          </h6>
          <div class="d-flex justify-content-between py-2 border-bottom"
               *ngFor="let r of comprobante.fees.refunded">
            <span class="text-muted text-truncate" style="max-width: 60%; font-size: 0.8rem;">
              {{ r.payment_code }}
            </span>
            <span class="fw-medium text-dark">$ {{ r.amount | number:'1.2-2' }} USD</span>
          </div>
          <div class="alert alert-warning p-2 mt-3 mb-0" role="alert">
            <span class="text-dark small">
              Estos pagos quedan con monto sin aplicar y deben revisarse.
            </span>
          </div>
        </div>

        <!-- Acciones -->
        <div class="d-grid gap-2 mt-4">
          <button class="btn btn-primary btn-lg" type="button" (click)="nuevaNota()">
            <i class="fas fa-plus me-2"></i>Registrar otra nota de crédito
          </button>
          <button class="btn btn-outline-secondary" type="button" (click)="irAPagos()">
            <i class="fas fa-receipt me-2"></i>Ver pagos del cliente
          </button>
        </div>

      </div>
    </div>
  </ng-container>
</div>
